export default "__VITE_ASSET__NSS0sga9__"